import React from 'react';

import { ReactComponent } from '../../assets/svg/warning_amber.svg';


export default () => <ReactComponent />;
